module.exports = __webpack_public_path__ + "img/img_empty.037eef9c.png";